import { useEffect } from "react";

const Contact = () => {
  useEffect(() => {
    document.title = "Contact - Deww Botanicals";
  }, []);

  return (
    <>
      <div className="container-fluid page-header"
      style={{ backgroundImage: `url(../assets/images/b_contact_us.jpg)`}}
      >
        <div className="container">
          <h1 className="display-5 mb-3 animated slideInDown">Contact Us</h1>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <span className="text-body">Home</span>
              </li>
              <li
                className="breadcrumb-item text-dark active"
                aria-current="page"
              >
                Contact
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="container-fluid py-4 py-md-5 bg-theme-light">
        <div className="container">
          <div className="row g-0 gx-5">
            <div className="col-lg-6">
              <div className="section-header mb-5 ">
                <h1 className="section-heading text-primary">Contact Us</h1>
                <p className="text-primary">
                  If you have any questions or would like to know more about our
                  products, please reach out to us.
                </p>
              </div>
            </div>
          </div>

          <div className="row g-0 gx-5">
            <div className="col-12 col-sm-6">
              <div className="map-wrapper">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3510.0086302517457!2d77.3491974!3d28.3888073!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cdd1d6a751e0d%3A0xb50860db233850c4!2sCrude%20Oil%20Aroma!5e0!3m2!1sen!2sin!4v1747322506904!5m2!1sen!2sin"
                  width="100%"
                  height="450"
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="rounded"
                  title="Google Map"
                ></iframe>
              </div>
            </div>

            <div className="col-12 col-sm-6 d-flex flex-column justify-content-center">
              <div className="contact-info bg-light rounded h-100 d-flex flex-column justify-content-center p-2 p-sm-5">
                <p>
                Plot No 149, Sector 86, Greater Faridabad,
                Haryana 121007
              </p>
              <p className="mb-0">
                Contact: 
                <a className="text-primary ms-1" Using target="_blank" without rel="noreferrer" href="tel:+919873036863">
                  +91 98 7303 6863
                </a>
              </p>
              <p className="mb-0">
                Contact: 
                <a className="text-primary ms-1" Using target="_blank" without rel="noreferrer" href="tel:+91 7206683112">
                  +91 72 0668 3112
                </a>
              </p>
              {/* <p className="mb-0">
                Bulk Order:{" "}
                <a
                  className="text-primary"
                  Using target="_blank" without rel="noreferrer" href="mailto:order@dewwbotanicals.com"
                >
                  order@dewwbotanicals.com
                </a>
              </p> */}
              <p className="mb-0">
                Email Support:{" "}
                <a
                  className="text-primary"
                  Using target="_blank" without rel="noreferrer" href="mailto:dewwbotanicals@gmail.com"
                >
                  dewwbotanicals@gmail.com
                </a>
              </p>
              <p>
                Email Support:{" "}
                <a
                  className="text-primary"
                  Using target="_blank" without rel="noreferrer" href="mailto:info@dewwbotanicals.com"
                >
                  info@dewwbotanicals.com
                </a>
              </p>
              <div className="d-flex pt-2">
                {/* <a
                  className="btn btn-square btn-outline-dark rounded-circle me-1"
                  Using target="_blank" without rel="noreferrer" href=""
                >
                  <i className="fab fa-twitter"></i>
                </a> */}
                <a
                  className="btn btn-square btn-outline-dark rounded-circle me-1"
                  Using target="_blank" without rel="noreferrer" href="https://www.instagram.com/deww_botanicals/"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a
                  className="btn btn-square btn-outline-dark rounded-circle me-1"
                  Using target="_blank" without rel="noreferrer" href="https://www.youtube.com/@DewwBotanicals"
                >
                  <i className="fab fa-youtube"></i>
                </a>
                <a
                  className="btn btn-square btn-outline-dark rounded-circle me-0"
                  Using target="_blank" without rel="noreferrer" href="https://www.linkedin.com/company/dewwbotanicals/"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
